
































import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { BACKEND_DATE_FORMAT } from "@/data/date";
import { IBasketConvertForm } from "@/models/baskets";

@Component
export default class BasketConvertFields extends Vue {
  // Inject

  @Inject({ from: "getConvertForm" })
  public readonly getConvertForm!: () => IBasketConvertForm;

  @Inject({ from: "setConvertForm" })
  public readonly setConvertForm!: (data: Partial<IBasketConvertForm>) => void;

  // Props

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Computed

  public get convertForm() {
    return this.getConvertForm();
  }

  // Life-cycle methods

  public created() {
    const { activation_date, next_due_date } = this.convertForm;
    if (!activation_date && !next_due_date)
      this.setConvertForm({
        activation_date: this.$moment().format(BACKEND_DATE_FORMAT),
        next_due_date: this.$moment().format(BACKEND_DATE_FORMAT)
      });
  }

  // Getters

  public get computedActivationDate() {
    return this.$moment(
      this.convertForm.activation_date ||
        this.$moment().format(BACKEND_DATE_FORMAT)
    ).format(this.$t("_datetime.date.long") as string);
  }

  public get computedNextDueDate() {
    return this.$moment(
      this.convertForm.next_due_date ||
        this.$moment().format(BACKEND_DATE_FORMAT)
    ).format(this.$t("_datetime.date.long") as string);
  }

  // Methods

  public selectActivationDate() {
    const activationMoment = this.$moment(this.convertForm.activation_date);
    this.$store.dispatch("ui/open/windowModal", {
      config: {
        component: () =>
          import("@/components/app/global/date/selectDateModal.vue"),
        parent: this,
        props: {
          title: this.$t("_action.change_next_renewal_date"),
          defaultDate: activationMoment.toDate(),
          minDate: this.$moment()
            .startOf("day")
            .toDate(),
          onSelect: date => {
            const activationMoment = this.$moment(date);
            const nextDueMoment = this.$moment(this.convertForm.next_due_date);
            this.setConvertForm({
              activation_date: activationMoment.format(BACKEND_DATE_FORMAT)
            });
            if (nextDueMoment < activationMoment)
              this.setConvertForm({
                next_due_date: activationMoment.format(BACKEND_DATE_FORMAT)
              });
          }
        },
        width: 440
      }
    });
  }

  public selectNextDueDate() {
    const nextDueMoment = this.$moment(this.convertForm.next_due_date);
    this.$store.dispatch("ui/open/windowModal", {
      config: {
        component: () =>
          import("@/components/app/global/date/selectDateModal.vue"),
        parent: this,
        props: {
          title: this.$t("_action.change_next_renewal_date"),
          defaultDate: nextDueMoment.toDate(),
          minDate: this.$moment(this.convertForm.activation_date)
            .startOf("day")
            .toDate(),
          onSelect: date => {
            this.setConvertForm({
              next_due_date: this.$moment(date).format(BACKEND_DATE_FORMAT)
            });
          }
        },
        width: 440
      }
    });
  }
}
